<template>
  <div>
    <v-snackbar
      top
      :color="snackbar.color"
      v-model="snackbar.model"
      timeout="1000"
      >{{ snackbar.msg }}</v-snackbar
    >

    <v-form v-model="valid" ref="form" @submit.prevent="create">
      <div v-for="(s, i) in sections" :key="i">
        <!-- sections -->
        <label v-bind="labelProps">Section #{{ i + 1 }}</label>
        <v-text-field
          v-model="s.description"
          :rules="[rules.required]"
          v-bind="fieldProps"
        >
          <v-icon
            v-if="sections.length > 1"
            icon
            slot="append"
            @click="onRemoveSection(i)"
          >
            mdi-delete
          </v-icon>
        </v-text-field>

        <v-list two-line>
          <!-- file upload -->
          <input
            id="fileInput"
            type="file"
            @input="pickFile"
            style="display: none"
            accept="image/png, image/jpeg, image/bmp"
          />

          <!-- options -->
          <v-list-item class="pa-0 ma-0" v-for="(o, j) in s.options" :key="j">
            <v-avatar
              tile
              color="grey lighten-1"
              size="60"
              class="mr-3 rounded-sm"
              @click="selectImage(i, j)"
              style="cursor: pointer"
            >
              <v-img
                v-if="o.previewImage || o.image_url"
                alt="avatar"
                :src="`${o.previewImage || o.image_url}`"
              >
              </v-img>
              <v-icon v-else dark> mdi-camera </v-icon>
            </v-avatar>

            <v-list-item-content class="pa-3 pr-0">
              <label v-bind="labelProps2">Option #{{ j + 1 }}</label>

              <v-text-field
                v-model="o.description"
                :rules="[rules.required]"
                v-bind="fieldProps"
              >
                <v-icon
                  v-if="s.options.length > 1"
                  icon
                  slot="append"
                  @click="onRemoveOption(i, j)"
                >
                  mdi-delete
                </v-icon>
              </v-text-field>
            </v-list-item-content>
          </v-list-item>

          <div
            :style="`padding-left: ${
              s.options[0].sub_options.length == 0 ? 0 : 120
            }px`"
          >
            <!-- suboptions -->
            <v-list-item
              class="pa-0 ma-0"
              v-for="(so, k) in s.options[0].sub_options"
              :key="`suboption-${k}`"
            >
              <v-list-item-content>
                <label v-bind="labelProps2">Suboption #{{ k + 1 }}</label>

                <v-text-field
                  v-model="so.description"
                  :rules="[rules.required]"
                  v-bind="fieldProps"
                >
                  <v-icon
                    v-if="s.options[0].sub_options.length > 0"
                    icon
                    slot="append"
                    @click="onRemoveSubOption(i, k)"
                  >
                    mdi-delete
                  </v-icon>
                </v-text-field>
              </v-list-item-content>
            </v-list-item>

            <!-- add suboption button -->
            <div
              class="d-flex justify-start mt-2 mb-6"
              v-if="s.options.length == 1"
            >
              <v-btn v-bind="btnProps" small @click="onAddSubOption(i)"
                >add suboption</v-btn
              >
            </div>
          </div>

          <!-- add option button -->
          <div class="d-flex justify-end mt-2">
            <v-btn
              v-bind="btnProps"
              @click="onAddOption(i)"
              :disabled="s.options[0].sub_options.length > 0"
              >add option
            </v-btn>
          </div>
        </v-list>
      </div>

      <!-- add section button and save button -->
      <div class="d-flex justify-end mt-5 mb-3">
        <v-btn class="mr-2" v-bind="btnProps" @click="onAddSection"
          >add section</v-btn
        >
        <v-btn
          :loading="loading"
          :disabled="loading"
          type="submit"
          v-bind="btnProps"
          class="primary"
          >save</v-btn
        >
      </div>
    </v-form>
  </div>
</template>

<script>
/* eslint-disable */
import {
  rules,
  fieldProps,
  btnProps,
  labelProps,
  labelProps2,
  toSentenceCase,
} from "@/helpers";
import { mapActions } from "vuex";

export default {
  data: () => ({
    rules,
    fieldProps,
    btnProps,
    labelProps,
    labelProps2,

    loading: false,
    valid: true,

    selectImageFor: {},

    snackbar: {
      model: false,
      msg: "Error!",
      color: "error",
    },

    sections: [
      {
        description: "",
        options: [
          {
            description: "",
            image_url: null,
            previewImage: null,
            file: null,
            sub_options: [],
          },
        ],
      },
    ],
  }),

  computed: {
    storeSections() {
      return this.$store.getters.getCollection("sections");
    },
  },

  methods: {
    ...mapActions(["makeFetch"]),

    showSnackbar(event) {
      this.snackbar.msg = toSentenceCase(event.msg);
      this.snackbar.color = event.color;
      this.snackbar.model = true;
    },

    async create() {
      if (!this.$refs.form.validate()) return;

      this.loading = true;
      const id = this.$route.params.id;

      for (let i = 0; i < this.sections.length; i++) {
        for (let j = 0; j < this.sections[i].options.length; j++) {
          if (this.sections[i].options[j].file) {
            const res = await this.uploadFile(this.sections[i].options[j].file);
            this.sections[i].options[j].image_url = res.url;
          }
        }
      }

      const data = this.sections.map((s, i) => {
        return {
          description: s.description,
          options: s.options.map((o, j) => {
            return {
              image_url: o.image_url,
              description: o.description,
              sub_options: o.sub_options,
            };
          }),
        };
      });

      const res = await this.makeFetch({
        method: "post",
        goTo: "/polls",
        useId: id,
        way: "/sections",
        data: { sections: data },
      })
        .catch(console.error)
        .finally(() => {
          this.loading = false;
        });

      this.showSnackbar({
        msg: res.data.message ? res.data.message : "Saved",
        color: res.data.message ? "error" : "primary",
      });
    },

    onRemoveSubOption(i, k) {
      this.sections[i].options[0].sub_options.splice(k, 1);
    },

    onRemoveOption(i, j) {
      this.sections[i].options.splice(j, 1);
    },

    onRemoveSection(i) {
      this.sections.splice(i, 1);
    },

    onAddSubOption(i) {
      this.sections[i].options[0].sub_options.push({
        description: "",
      });
    },

    onAddOption(i) {
      this.sections[i].options.push({
        description: "",
        image_url: null,
        previewImage: null,
        file: null,
        sub_options: [],
      });
    },

    onAddSection() {
      this.sections.push({
        description: "",
        options: [
          {
            description: "",
            image_url: null,
            previewImage: null,
            file: null,
            sub_options: [],
          },
        ],
      });
    },

    selectImage(i, j) {
      this.selectImageFor.i = i;
      this.selectImageFor.j = j;
      document.getElementById("fileInput").click();
    },

    pickFile() {
      let input = document.getElementById("fileInput");
      let file = input.files;
      if (file && file[0]) {
        let reader = new FileReader();

        const { i, j } = this.selectImageFor;
        this.sections[i].options[j].file = file[0];

        reader.onload = (e) => {
          this.sections[i].options[j].previewImage = e.target.result;
        };
        reader.readAsDataURL(file[0]);
        this.$emit("input", file[0]);
      }
    },

    async uploadFile(file) {
      if (!file) return { url: "" };
      const res = await this.uploadFileToCloudinary(file);
      return res;
    },

    uploadFileToCloudinary(file) {
      return new Promise(function (resolve, reject) {
        const CLOUDNAME = "dopwrcltl";
        // Ideally these to lines would be in a .env file
        const CLOUDINARY_URL = `https://api.cloudinary.com/v1_1/${CLOUDNAME}/upload`;
        const CLOUDINARY_UPLOAD_PRESET = "wiittfvt";

        let formData = new FormData();
        formData.append("upload_preset", CLOUDINARY_UPLOAD_PRESET);
        formData.append("folder", "cloudinary-demo");
        formData.append("file", file);

        let request = new XMLHttpRequest();
        request.open("POST", CLOUDINARY_URL, true);
        request.setRequestHeader("X-Requested-With", "XMLHttpRequest");

        request.onreadystatechange = () => {
          // File uploaded successfully
          if (request.readyState === 4 && request.status === 200) {
            let response = JSON.parse(request.responseText);
            resolve(response);
          }

          // Not succesfull, let find our what happened
          if (request.status !== 200) {
            let response = JSON.parse(request.responseText);
            let error = response.error.message;
            alert("error, status code not 200 " + error);
            reject(error);
          }
        };

        request.onerror = (err) => {
          alert("error: " + err);
          reject(err);
        };

        request.send(formData);
      });
    },
  },

  async mounted() {
    await this.makeFetch({
      method: "get",
      goTo: `/polls/${this.$route.params.id}`,
      way: "/sections",
      stateVar: "sections",
    }).catch(console.error);
  },

  watch: {
    storeSections(val) {
      const v = val.map((s, i) => {
        return {
          description: s.description,
          options: s.options.map((o, j) => {
            return {
              image_url: o.image_url,
              description: o.description,
              sub_options: o.sub_options,
              previewImage: null,
              file: null,
            };
          }),
        };
      });

      this.sections = [...v];
      this.onAddSection();
    },
  },
};
</script>
